
import { state } from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default function extendCart (storeCart) {
  storeCart.state = { ...storeCart.state, ...state(storeCart) }
  storeCart.getters = { ...storeCart.getters, ...getters }
  storeCart.mutations = { ...storeCart.mutations, ...mutations }
  storeCart.actions = { ...storeCart.actions, ...actions }
  return storeCart
}
